import * as Store from 'store'
import { IRootState } from 'store';
import { NotificationMessageType } from 'store/modules/notifications';
import { scrollToTop } from './navigation';

/** Fail Handler */
export const onFail = (message, dispatch, err?) => {
    //Errors show on top make sure user can see it
    scrollToTop();
    let error = String(err || '');
    if (err) {
        if (err.response && err.response.data) {
            console.debug(err.response.data);
            if (err.response.data.message && (typeof (err.response.data.message) === 'string')) {
                error = String(err.response.data.message);
            }
        } else if (err.message) {
            error = err.message
        } else if (err.errorDescription) {
            error = err.errorDescription
        }
    }
    dispatch(Store.Notifications.raiseError(message, error));
}

/** Success Confirmation Handler */
export const onSuccess = (message, dispatch, details?) => {
    //Confirmation show on top make sure user can see it
    scrollToTop();
    dispatch(Store.Notifications.raiseSuccess(message, details));
}

export const clearUserMessages = (dispatch) => {
    dispatch(Store.Notifications.clearNotifications());
}

const userNotificationTypes = [NotificationMessageType.info, NotificationMessageType.confirm, NotificationMessageType.warn, NotificationMessageType.error];

export const getUserNotifications = (state: IRootState) => {
    return getNotificationsByType(state, userNotificationTypes);
}

/** Select notification messages of specific type */
export const getNotificationsByType = ({ notifications }: IRootState, includeTypes: NotificationMessageType[]) => {
    return (notifications && notifications.messages) ? notifications.messages.filter(m => includeTypes.includes(m.type)) : [];
}



// WEBPACK FOOTER //
// ./src/application/operation.ts